export const ERRORS = {
  VOLUME_SLOW_DEVICE: {
    CODE: 'VOLUME_SLOW_DEVICE',
    TITLE: 'Flow slowed/ stopped',
    MESSAGE: 'Volume change in sample solution below some threshold.',
  },
  VOLUME_FAST_DEVICE: {
    CODE: 'VOLUME_FAST_DEVICE',
    TITLE: 'Flow fast/ stopped',
    MESSAGE: 'Volume change in sample solution above some threshold.',
  },
  VOLUME_CHANGES_SIGNIFICANLY: {
    CODE: 'VOLUME_CHANGES_SIGNIFICANLY',
    TITLE: 'Tube volume changes significantly',
    MESSAGE:
      'The system detected the volume of the tube has changed significantly above the threshold. The current profile must be stopped. You can run another profile using the current volume or adjust the volume to the initial value.',
  },
  VOLUME_SENSOR_NOT_RESPONDING: {
    CODE: 'VOLUME_SENSOR_NOT_RESPONDING',
    TITLE: 'Volume Sensor Is Not Responding',
    MESSAGE:
      'The volume sensor is not responding and the current profile must be stopped. Check the accuracy of the scales in the Calibration Wizard before running another profile, the device may need to be restarted. Contact support@formulatrix.com if the problem persists.',
  },
  VOLUME_SENSOR_TUBE_NOT_AVAILABLE: {
    CODE: 'VOLUME_SENSOR_TUBE_NOT_AVAILABLE',
    TITLE: 'Tube Not Available',
    MESSAGE:
      'The system detected the volume of the tube has changed significantly. Please make sure the tubes are in the right place and then continue the profile.',
  },
};
export const VolumeThreshold = 'VolumeThreshold';
